import { render, staticRenderFns } from "./FederationSettings.vue?vue&type=template&id=999f29b8&scoped=true&"
import script from "./FederationSettings.vue?vue&type=script&lang=js&"
export * from "./FederationSettings.vue?vue&type=script&lang=js&"
import style0 from "./FederationSettings.vue?vue&type=style&index=0&id=999f29b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "999f29b8",
  null
  
)

export default component.exports